import { use } from 'react';
import { naturalStringCompare } from '../../../common/src/util.ts';
import { HymnalsContext } from '../data/use_hymnals.tsx';
import { PrimaryOrgHymnalId } from '../util/path.ts';
import '../util/shared.css';
import { HymnsList, LibraryPageTitle } from '../views/hymns_list.tsx';

export const LibraryPage = () => {
  const hymnals = use(HymnalsContext);
  // include "our hymnal" sorted to top
  const libraryHymnals = hymnals.sort((lhs, rhs) =>
    lhs.id === PrimaryOrgHymnalId ? -1 : rhs.id === PrimaryOrgHymnalId ? 1 : naturalStringCompare(lhs.name, rhs.name),
  );
  return <HymnsList hymnals={libraryHymnals} title={LibraryPageTitle} isCurrentHymnalSticky={true} showProfileAvatar />;
};
